import { render, staticRenderFns } from "./AssignmentItem.vue?vue&type=template&id=40eddc6b&scoped=true&"
import script from "./AssignmentItem.vue?vue&type=script&lang=js&"
export * from "./AssignmentItem.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentItem.vue?vue&type=style&index=0&id=40eddc6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40eddc6b",
  null
  
)

export default component.exports